import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import Btn from 'components/buttons/Btn'
import { FormCollapse } from 'components/form'
import GMBModal from 'pages/Settings/GMBModal'
import TextSize from 'pages/Settings/TextSize'
import { Alert, Card, Form, ListGroup } from 'react-bootstrap'
import { Trans, useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useAccount } from 'state/Account'
import { getIsCMO } from 'state/Reseller'
import { saveLocale } from 'state/Settings'
import { klass, Locale, useModalState, WakeLock } from 'utils'

/**
 * @param caffeineFieldState {array} Generated by useFieldState
 * @returns {JSX.Element}
 */
export default function OtherSettings({ caffeineFieldState }) {
	const { t }         = useTranslation()
	const dispatch      = useDispatch()
	const gmbModal      = useModalState()
	const isCMO         = useSelector(getIsCMO)
	const locale        = new Locale()
	const appUrl        = useAccount().app_url
	const wakeLockWorks = WakeLock.works()

	const [caffeine, , caffeineField] = caffeineFieldState

	function doTranslate({ target }) {
		dispatch(saveLocale(target.value))
	}

	return <Card>
		<Card.Header><Icon icon="asterisk"/> {t('Other settings')}</Card.Header>
		<ListGroup variant="flush">
			<ListGroup.Item>
				<Form.Group controlId="caffeine">
					<Form.Switch label={<>{t('Always on screen')} <CaffeineIndicator/></>} {...caffeineField}
					             disabled={!wakeLockWorks} {...klass({ caffeineOn: caffeine && wakeLockWorks })}/>
					<FormCollapse in={!wakeLockWorks}>
						<Alert variant="warning">
							{t('This feature doesn\'t work yet in this browser.')}{' '}
							{appUrl?
								<><Trans>We suggest you to use the <a href={appUrl}>native app</a> instead.</Trans></> :
								t('We suggest you to use Chrome v84 or greater.')}
						</Alert>
					</FormCollapse>
				</Form.Group>
			</ListGroup.Item>

			<ListGroup.Item>
				<Form.Group>
					<Form.Label htmlFor="lang">
						{t('Language:')} {!Locale.isSibling(Locale.DEFAULT, locale.current()) && ' (language)'}
					</Form.Label>
					<Form.Control as="select" id="lang" defaultValue={locale.current()} onChange={doTranslate}>
						{locale.AVAILABLE.map(lang => (
							<option value={lang.code} key={lang.code}>
								{t(lang.name)}
								{!Locale.isSibling(locale.current(), lang.code) && ` - ${t(lang.name, { lng: lang.code })}`}
							</option>
						))}
					</Form.Control>
				</Form.Group>
			</ListGroup.Item>

			{isCMO && <>
				<ListGroup.Item>
					<Form.Label>{t('Google My Business:')}</Form.Label>
					<Form.Group controlId="GMBPin">
						<Btn variant="outline-dark" swap icon="store" onClick={gmbModal.doOpen}>{t('Send a new PIN')}</Btn>
					</Form.Group>
				</ListGroup.Item>
				<GMBModal {...gmbModal}/>
			</>}

			<TextSize/>

		</ListGroup>
	</Card>
}

function CaffeineIndicator() {
	return <span className="fa-layers fa-fw" id="coffee-mug">
	   <Icon icon="mug-hot" size="lg"/>
	   <Icon icon="play" transform="shrink-3 up-8 left-4" rotation={270}/>
	   <Icon icon="minus" transform="grow-5 down-13 left-1"/>
	   <Icon icon="minus" transform="grow-10 down-16 left-2"/>
	</span>
}
